<aside class="sidebar d-none d-md-block" [class.collapsed]="isCollapsed">
  <div class="header d-flex justify-content-center">
    <div class="header-content d-flex justify-content-center" [class.collapsed]="isCollapsed">
      <div class="logo d-flex justify-content-center">
        <a [routerLink]="homeRoute" class="logo-link d-flex justify-content-center">
          <img
            [src]="isCollapsed ? 'assets/images/header-logo.svg' : 'assets/images/main-logo.svg'"
            alt="Whopper Ads Logo"
            class="logo-image"
            [width]="isCollapsed ? 30 : 120"
            [height]="isCollapsed ? 30 : 70"
          />
        </a>
      </div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <!-- Dashboard -->
    @if (!has(PERMISSIONS.DASHBOARD.SUPER_ADMIN) && has(PERMISSIONS.DASHBOARD.VIEW)) {
      <a routerLink="/dashboard" routerLinkActive="active">
        <i class="bi bi-speedometer2"></i>
        <span class="label">Dashboard</span>
      </a>
    }

    @if (has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/super-admin-dashboard" routerLinkActive="active">
        <i class="bi bi-speedometer2"></i>
        <span class="label">Super Admin Dashboard</span>
      </a>
    }

    <!-- Client Lead Dashboard -->
    <!-- <a routerLink="/client-lead-dashboard" routerLinkActive="active">
      <i class="bi bi-bar-chart-line"></i>
      <span class="label">Lead Dashboard</span>
    </a> -->

    <!-- Internal Lead Dashboard (Admin/Internal only) -->
    @if (has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/internal-lead-dashboard" routerLinkActive="active">
        <i class="bi bi-clipboard-data"></i>
        <span class="label">Internal Lead Dashboard</span>
      </a>
    }

    <!-- Apartments -->
    @if (has(PERMISSIONS.APARTMENT.VIEW)) {
      <a routerLink="/apartments" routerLinkActive="active">
        <i class="bi bi-building"></i>
        <span class="label">Apartments</span>
      </a>
    }

    <!-- Tech Parks -->
    @if (has(PERMISSIONS.TECH_PARK.VIEW)) {
      <a routerLink="/tech-parks" routerLinkActive="active">
        <i class="bi bi-building"></i>
        <span class="label">Tech Parks</span>
      </a>
    }

    <!-- Malls -->
    @if (has(PERMISSIONS.MALL.VIEW)) {
      <a routerLink="/malls" routerLinkActive="active">
        <i class="bi bi-building"></i>
        <span class="label">Malls</span>
      </a>
    }

    <!-- Hoardings -->
    @if (has(PERMISSIONS.HOARDING.VIEW)) {
      <a routerLink="/hoardings" routerLinkActive="active">
        <i class="bi bi-bounding-box"></i>
        <span class="label">Hoardings</span>
      </a>
    }

    <!-- Activations -->
    @if (has(PERMISSIONS.ACTIVATION.VIEW)) {
      <a routerLink="/activations" routerLinkActive="active">
        <i class="bi bi-lightning"></i>
        <span class="label">Activations</span>
      </a>
    }

    <!-- Projects -->
    @if (has(PERMISSIONS.PROJECT.VIEW)) {
      <a routerLink="/projects" routerLinkActive="active">
        <i class="bi bi-folder"></i>
        <span class="label">Projects</span>
      </a>
    }

    <!-- Clients -->
    @if (has(PERMISSIONS.CLIENT.VIEW)) {
      <a routerLink="/clients" routerLinkActive="active">
        <i class="bi bi-person-workspace"></i>
        <span class="label">Clients</span>
      </a>
    }

    @if (has(PERMISSIONS.EXPENSES.VIEW)) {
      <a routerLink="/expenses" routerLinkActive="active">
        <i class="bi bi-receipt"></i>
        <span class="label">Expenses</span>
      </a>
    }

    @if (has(PERMISSIONS.EXPENSE_CATEGORY.VIEW)) {
      <a routerLink="/expense-categories" routerLinkActive="active">
        <i class="bi bi-tags"></i>
        <span class="label">Expense Categories</span>
      </a>
    }

    <!--  Promoters -->
    @if (has(PERMISSIONS.PROMOTER.VIEW)) {
      <a routerLink="/promoters" routerLinkActive="active">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">Promoters</span>
      </a>
    }
    <!-- Activation Promoters -->
    @if (has(PERMISSIONS.ACTIVATION_PROMOTER.VIEW)) {
      <!-- <a routerLink="/activation-promoters" routerLinkActive="active">
        <i class="bi bi-megaphone"></i>
        <span class="label">Activation Promoters</span>
      </a> -->
    }

    <!-- Materials -->
    @if (has(PERMISSIONS.MATERIAL.VIEW)) {
      <a routerLink="/materials" routerLinkActive="active">
        <i class="bi bi-box-seam"></i>
        <span class="label">Materials</span>
      </a>
    }

    @if (has(PERMISSIONS.MATERIAL.VIEW)) {
      <a routerLink="/material-purchases" routerLinkActive="active">
        <i class="bi bi-bag-check"></i>
        <span class="label">Material Purchases</span>
      </a>
    }

    <!-- Inventory -->
    @if (has(PERMISSIONS.INVENTORY.VIEW)) {
      <a routerLink="/inventories" routerLinkActive="active">
        <i class="bi bi-archive"></i>
        <span class="label">Inventory</span>
      </a>
    }

    <!-- Activation Assignment -->
    <!-- @if (has(PERMISSIONS.ACTIVATION_ASSIGNMENT.VIEW)) {
      <a routerLink="/activation-assignment" routerLinkActive="active">
        <i class="bi bi-diagram-2"></i>
        <span class="label">Activation Assignment</span>
      </a>
    } -->

    <!-- Leads -->
    @if (has(PERMISSIONS.LEAD.VIEW)) {
      <a routerLink="/leads" routerLinkActive="active">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">Leads Capture</span>
      </a>
    }

    <!-- HR - Applicants -->
    @if (has(PERMISSIONS.APPLICANT.VIEW)) {
      <a routerLink="/applicants" routerLinkActive="active">
        <i class="bi bi-person-badge"></i>
        <span class="label">HR - Applicants</span>
      </a>
    }

    <!-- Users -->
    @if (has(PERMISSIONS.USER.VIEW)) {
      <a routerLink="/users" routerLinkActive="active">
        <i class="bi bi-people"></i>
        <span class="label">Users</span>
      </a>
    }

    @if (hasAny([PERMISSIONS.FEEDBACK.VIEW, PERMISSIONS.FEEDBACK.VIEW_ALL])) {
      <a routerLink="/feedbacks" routerLinkActive="active">
        <i class="bi bi-chat-left-text-fill"></i>
        <span class="label">Feedbacks</span>
      </a>
    }

    <!-- Masters Group -->
    @if (
      hasAny([
        PERMISSIONS.LOCATION.STATE_VIEW,
        PERMISSIONS.LOCATION.CITY_VIEW,
        PERMISSIONS.BRANCH.VIEW,
        PERMISSIONS.VENDOR.VIEW,
        PERMISSIONS.PROMOTION_CHANNEL.VIEW,
        PERMISSIONS.PROMOTION_DURATION.VIEW,
        PERMISSIONS.SOURCE.VIEW,
        PERMISSIONS.POSITION.VIEW,
        PERMISSIONS.DISABLE_REASON.VIEW,
        PERMISSIONS.ROLE.VIEW,
      ])
    ) {
      <div class="menu-group me-2">
        <button
          class="dropdown-toggle"
          [class.open]="isMasterDataOpen"
          (click)="toggleMasterData()"
        >
          <i class="bi bi-database"></i>
          <span class="label">Masters</span>
        </button>

        <div class="dropdown" [class.open]="isMasterDataOpen">
          @if (has(PERMISSIONS.LOCATION.STATE_VIEW)) {
            <a routerLink="/states" routerLinkActive="active">
              <i class="bi bi-map"></i>
              <span class="label">States</span>
            </a>
          }

          @if (has(PERMISSIONS.LOCATION.CITY_VIEW)) {
            <a routerLink="/cities" routerLinkActive="active">
              <i class="bi bi-building"></i>
              <span class="label">Cities</span>
            </a>
          }

          @if (has(PERMISSIONS.BRANCH.VIEW)) {
            <a routerLink="/branches" routerLinkActive="active">
              <i class="bi bi-diagram-3"></i>
              <span class="label">Branches</span>
            </a>
          }

          @if (has(PERMISSIONS.VENDOR.VIEW)) {
            <a routerLink="/vendors" routerLinkActive="active">
              <i class="bi bi-shop"></i>
              <span class="label">Vendors</span>
            </a>
          }

          @if (has(PERMISSIONS.PROMOTION_CHANNEL.VIEW)) {
            <a routerLink="/promotion-channels" routerLinkActive="active">
              <i class="bi bi-broadcast"></i>
              <span class="label">Promotion Channels</span>
            </a>
          }

          @if (has(PERMISSIONS.PROMOTION_DURATION.VIEW)) {
            <a routerLink="/promotion-durations" routerLinkActive="active">
              <i class="bi bi-hourglass-split"></i>
              <span class="label">Promotion Durations</span>
            </a>
          }

          @if (has(PERMISSIONS.SOURCE.VIEW)) {
            <a routerLink="/sources" routerLinkActive="active">
              <i class="bi bi-folder-plus"></i>
              <span class="label">Source</span>
            </a>
          }

          @if (has(PERMISSIONS.POSITION.VIEW)) {
            <a routerLink="/positions" routerLinkActive="active">
              <i class="bi bi-briefcase"></i>
              <span class="label">Position</span>
            </a>
          }

          @if (has(PERMISSIONS.DISABLE_REASON.VIEW)) {
            <a routerLink="/disable-reasons" routerLinkActive="active">
              <i class="bi bi-slash-circle"></i>
              <span class="label">Disable Reason</span>
            </a>
          }

          @if (has(PERMISSIONS.ROLE.VIEW)) {
            <a routerLink="/roles" routerLinkActive="active">
              <i class="bi bi-shield-lock"></i>
              <span class="label">Roles</span>
            </a>
          }
        </div>
      </div>
    }
  </nav>
</aside>
<!-- Mobile Side bar -->
<aside class="mobile-sidebar" [class.open]="isMobileOpen">
  <!-- Header -->
  <div class="mobile-header">
    <h5>Menu</h5>
    <button class="mobile-close-btn" (click)="closeMobile.emit()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Navigation -->
  <nav class="mobile-nav">
    <!-- Dashboard -->
    @if (!has(PERMISSIONS.DASHBOARD.SUPER_ADMIN) && has(PERMISSIONS.DASHBOARD.VIEW)) {
      <a routerLink="/dashboard" routerLinkActive="active" class="menu-item">
        <i class="bi bi-speedometer2"></i>
        <span>Dashboard</span>
      </a>
    }

    @if (has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/super-admin-dashboard" routerLinkActive="active" class="menu-item">
        <i class="bi bi-speedometer2"></i>
        <span>Super Admin Dashboard</span>
      </a>
    }

    <!-- Client Lead Dashboard -->
    <!-- <a routerLink="/client-lead-dashboard" routerLinkActive="active" class="menu-item">
      <i class="bi bi-bar-chart-line"></i>
      <span>Lead Dashboard</span>
    </a> -->

    <!-- Internal Lead Dashboard (Admin/Internal only) -->
    @if (has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/internal-lead-dashboard" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clipboard-data"></i>
        <span>Internal Lead Dashboard</span>
      </a>
    }

    @if (has(PERMISSIONS.APARTMENT.VIEW)) {
      <a routerLink="/apartments" routerLinkActive="active" class="menu-item">
        <i class="bi bi-building"></i>
        <span>Apartments</span>
      </a>
    }

    @if (has(PERMISSIONS.TECH_PARK.VIEW)) {
      <a routerLink="/tech-parks" routerLinkActive="active" class="menu-item">
        <i class="bi bi-building"></i>
        <span>Tech Parks</span>
      </a>
    }

    @if (has(PERMISSIONS.MALL.VIEW)) {
      <a routerLink="/malls" routerLinkActive="active" class="menu-item">
        <i class="bi bi-building"></i>
        <span>Malls</span>
      </a>
    }

    @if (has(PERMISSIONS.HOARDING.VIEW)) {
      <a routerLink="/hoardings" routerLinkActive="active" class="menu-item">
        <i class="bi bi-bounding-box"></i>
        <span>Hoardings</span>
      </a>
    }

    @if (has(PERMISSIONS.ACTIVATION.VIEW)) {
      <a routerLink="/activations" routerLinkActive="active" class="menu-item">
        <i class="bi bi-lightning"></i>
        <span>Activations</span>
      </a>
    }

    @if (has(PERMISSIONS.PROJECT.VIEW)) {
      <a routerLink="/projects" routerLinkActive="active" class="menu-item">
        <i class="bi bi-folder"></i>
        <span>Projects</span>
      </a>
    }

    @if (has(PERMISSIONS.CLIENT.VIEW)) {
      <a routerLink="/clients" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-workspace"></i>
        <span>Clients</span>
      </a>
    }

    @if (has(PERMISSIONS.EXPENSES.VIEW)) {
      <a routerLink="/expenses" routerLinkActive="active" class="menu-item">
        <i class="bi bi-receipt"></i>
        <span>Expenses</span>
      </a>
    }

    @if (has(PERMISSIONS.EXPENSE_CATEGORY.VIEW)) {
      <a routerLink="/expense-categories" routerLinkActive="active" class="menu-item">
        <i class="bi bi-tags"></i>
        <span>Expense Categories</span>
      </a>
    }

    @if (has(PERMISSIONS.ACTIVATION_PROMOTER.VIEW)) {
      <!-- <a routerLink="/activation-promoters" routerLinkActive="active" class="menu-item">
        <i class="bi bi-megaphone"></i>
        <span>Activation Promoters</span>
      </a> -->
    }

    @if (has(PERMISSIONS.MATERIAL.VIEW)) {
      <a routerLink="/materials" routerLinkActive="active" class="menu-item">
        <i class="bi bi-box-seam"></i>
        <span>Materials</span>
      </a>
    }

    @if (has(PERMISSIONS.MATERIAL.VIEW)) {
      <a routerLink="/material-purchases" routerLinkActive="active" class="menu-item">
        <i class="bi bi-bag-check"></i>
        <span>Material Purchases</span>
      </a>
    }

    @if (has(PERMISSIONS.INVENTORY.VIEW)) {
      <a routerLink="/inventories" routerLinkActive="active" class="menu-item">
        <i class="bi bi-archive"></i>
        <span>Inventory</span>
      </a>
    }

    <!-- @if (has(PERMISSIONS.ACTIVATION_ASSIGNMENT.VIEW)) {
      <a routerLink="/activation-assignment" routerLinkActive="active" class="menu-item">
        <i class="bi bi-diagram-2"></i>
        <span>Activation Assignment</span>
      </a>
    } -->

    @if (has(PERMISSIONS.LEAD.VIEW)) {
      <a routerLink="/leads" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-lines-fill"></i>
        <span>Leads Capture</span>
      </a>
    }

    @if (has(PERMISSIONS.APPLICANT.VIEW)) {
      <a routerLink="/applicants" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-badge"></i>
        <span>HR - Applicants</span>
      </a>
    }

    @if (has(PERMISSIONS.USER.VIEW)) {
      <a routerLink="/users" routerLinkActive="active" class="menu-item">
        <i class="bi bi-people"></i>
        <span>Users</span>
      </a>
    }
    @if (hasAny([PERMISSIONS.FEEDBACK.VIEW, PERMISSIONS.FEEDBACK.VIEW_ALL])) {
      <a routerLink="/feedbacks" routerLinkActive="active" class="menu-item">
        <i class="bi bi-chat-left-text-fill"></i>
        <span>Feedbacks</span>
      </a>
    }
    <!--  Promoters -->
    @if (has(PERMISSIONS.PROMOTER.VIEW)) {
      <a routerLink="/promoters" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">Promoters</span>
      </a>
    }

    <!-- Masters Section -->
    @if (
      hasAny([
        PERMISSIONS.LOCATION.STATE_VIEW,
        PERMISSIONS.LOCATION.CITY_VIEW,
        PERMISSIONS.BRANCH.VIEW,
        PERMISSIONS.VENDOR.VIEW,
        PERMISSIONS.PROMOTION_CHANNEL.VIEW,
        PERMISSIONS.PROMOTION_DURATION.VIEW,
        PERMISSIONS.SOURCE.VIEW,
        PERMISSIONS.POSITION.VIEW,
        PERMISSIONS.DISABLE_REASON.VIEW,
        PERMISSIONS.ROLE.VIEW,
      ])
    ) {
      <div class="master-section">
        <button
          class="dropdown-toggle"
          [class.open]="isMasterDataOpen"
          (click)="toggleMasterData()"
        >
          <i class="bi bi-database"></i>
          <span>Masters</span>
        </button>

        <div class="dropdown" [class.open]="isMasterDataOpen">
          @if (has(PERMISSIONS.LOCATION.STATE_VIEW)) {
            <a routerLink="/states" routerLinkActive="active" class="submenu-item"> States </a>
          }

          @if (has(PERMISSIONS.LOCATION.CITY_VIEW)) {
            <a routerLink="/cities" routerLinkActive="active" class="submenu-item"> Cities </a>
          }

          @if (has(PERMISSIONS.BRANCH.VIEW)) {
            <a routerLink="/branches" routerLinkActive="active" class="submenu-item"> Branches </a>
          }

          @if (has(PERMISSIONS.VENDOR.VIEW)) {
            <a routerLink="/vendors" routerLinkActive="active" class="submenu-item"> Vendors </a>
          }

          @if (has(PERMISSIONS.PROMOTION_CHANNEL.VIEW)) {
            <a routerLink="/promotion-channels" routerLinkActive="active" class="submenu-item">
              Promotion Channels
            </a>
          }

          @if (has(PERMISSIONS.PROMOTION_DURATION.VIEW)) {
            <a routerLink="/promotion-durations" routerLinkActive="active" class="submenu-item">
              Promotion Durations
            </a>
          }

          @if (has(PERMISSIONS.SOURCE.VIEW)) {
            <a routerLink="/sources" routerLinkActive="active" class="submenu-item"> Source </a>
          }

          @if (has(PERMISSIONS.POSITION.VIEW)) {
            <a routerLink="/positions" routerLinkActive="active" class="submenu-item"> Position </a>
          }

          @if (has(PERMISSIONS.DISABLE_REASON.VIEW)) {
            <a routerLink="/disable-reasons" routerLinkActive="active" class="submenu-item">
              Disable Reason
            </a>
          }

          @if (has(PERMISSIONS.ROLE.VIEW)) {
            <a routerLink="/roles" routerLinkActive="active" class="submenu-item"> Roles </a>
          }
        </div>
      </div>
    }
  </nav>
</aside>
